import { Base } from '@studiometa/js-toolkit';

/**
 * ListingLetters component
 */
export default class ListingLetters extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ListingLetters',
    refs: ['reset', 'select', 'letters[]'],
    emits: ['change'],
  };

  /**
   * Set select value on letters click
   * @param {Event} e
   * @param {number} index
   */
  onLettersClick(e, index) {
    [this.$refs.letters, this.$refs.reset].flat().forEach((el) => {
      el.setAttribute('aria-selected', false);
    });

    const letter = this.$refs.letters[index];
    letter.setAttribute('aria-selected', true);

    this.$refs.select.value = letter.dataset.letter;
    this.$emit('change');
  }

  /**
   * Reset select on reset click
   */
  onResetClick() {
    this.$refs.letters.forEach((el) => {
      el.setAttribute('aria-selected', false);
    });

    this.$refs.reset.setAttribute('aria-selected', true);

    this.$refs.select.value = -1;
    this.$emit('change');
  }
}
